module.exports = __webpack_public_path__ + "static/RemoteAssistance-b5d18028c01f98abcf7c16c65b4a496b.png";